export const PERFORMANCE_DASHBOARD_FILTERS_KEY = 'performanceDashboardFilters';
// Separate filter storage for when partner score FF is ON vs OFF
export const PERFORMANCE_DASHBOARD_FILTERS_WITH_PARTNER_SCORE_KEY =
  'performanceDashboardFiltersWithPartnerScore';
export const NAVBAR_COLLAPSED_KEY = 'navbarCollapsed';
export const OFFLINE_PARTNER_SHEET_SETUP_KEY = 'offlinePartnerSheetSetup';
export const SALESFORCE_APP_INSTALL_KEY = 'salesforceAppInstall';

export const STORAGE_KEYS_TO_CLEAR_ON_ORG_SWITCH = [
  {
    key: PERFORMANCE_DASHBOARD_FILTERS_KEY,
    storage: sessionStorage,
  },
  {
    key: PERFORMANCE_DASHBOARD_FILTERS_WITH_PARTNER_SCORE_KEY,
    storage: sessionStorage,
  },
  {
    key: OFFLINE_PARTNER_SHEET_SETUP_KEY,
    storage: sessionStorage,
  },
  {
    key: SALESFORCE_APP_INSTALL_KEY,
    storage: sessionStorage,
  },
] as const;
